import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer aria-label="Site footer" className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <picture>
                <source srcSet="/images/logos/my-logo192.webp" type="image/webp" />
                <img src="/images/logos/my-logo192.png" alt="" aria-hidden="true" width="32" height="32" className="h-8 w-8" />
              </picture>
              <span className="text-xl font-bold">StrikeAPrice</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              AI-powered price monitoring and dynamic pricing software for
              modern businesses. Monitor, analyze, and optimize your pricing
              strategy with real-time market data.
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2 text-gray-400">
                <Mail className="h-4 w-4" />
                <span>support@strikeaprice.com</span>
              </div>
            </div>
            <div className="flex space-x-3 mt-4">
              <a
                href="https://www.linkedin.com/company/strikeaprice-ai"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="StrikeAPrice on LinkedIn"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Solutions</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/dynamic-pricing"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Dynamic Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/google-shopping"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Google Shopping
                </Link>
              </li>
              <li>
                <Link
                  to="/marketplace-monitoring"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Marketplace Monitoring
                </Link>
              </li>
              <li>
                <Link
                  to="/competitor-monitoring"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Competitor Monitoring
                </Link>
              </li>
              <li>
                <Link
                  to="/map-alerts"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  MAP Alerts
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/help"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Help & Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/trial"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Start Trial
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2010–2026 StrikeAPrice. All rights reserved.</p>
          <p className="text-sm mt-1">A product of Liya Aathira Private Limited <span className="text-gray-400">(formerly Marlen India Private Limited)</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
